import React from 'react';
import logo from '../imgs/otros/juego rio-15.png';
import '../styles/logoAnimado.css';

export default function LogoAnimado() {
    return (
        <div className='logoAnimado__div--container'>
            <img className='logoAnimado__img' src={logo} alt='logo.png'/>
        </div>
    )
}
